import { render, staticRenderFns } from "./promotion_coupon_redemption.vue?vue&type=template&id=52569fea&"
import script from "./promotion_coupon_redemption.vue?vue&type=script&lang=js&"
export * from "./promotion_coupon_redemption.vue?vue&type=script&lang=js&"
import style0 from "./promotion_coupon_redemption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../vue/rewards-admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports